<template>
	<div id="modalAlbumSet" class="modal fade" data-backdrop="static">
		<div class="modal-dialog modal-dialog-vertical-center modal-lg">
			<div class="modal-content bd-0 tx-14">
				<modal-loading :show="loading"></modal-loading>
				<div class="modal-header pd-y-20 pd-x-25">
					<h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("outside.相册空间升级续费")}}</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
			            <span aria-hidden="true">×</span>
			        </button>
				</div>
				<div class="modal-body pd-25 model-auto-h">
					<div class="d-flex align-items-center mg-b-20">
						<span class="mg-r-10">{{$t("outside.当前套餐：")}}</span>
						<span class="tx-gray-900" v-if="albumNow == 0">{{$t("outside.1G免费容量")}}</span>
						<span class="tx-gray-900" v-else>{{albumNow}}{{$t("outside.G容量")}}</span>
					</div>
					<div class="d-flex align-items-center mg-b-20">
						<span class="mg-r-10">{{$t("outside.可选套餐：")}}</span>
						<div class="d-flex align-items-center col-md-10 pd-0" v-if="albumConfig.albumType<3">
							<div class="col-4 pd-l-0" v-for="(album,index) in albumSets" v-if="album.isAvailable">
								<div class="set-warp" :class="active == index ? 'active' : ''" @click="getActive(index)">
									<div class="set-top tx-center">
										<div class="tx-black tx-24">{{album.size}}GB</div>
										<div class="tx-gray-900 mg-t-15 pd-t-15" style="border-top: 1px dashed #ddd;">{{$t("outside.可存储约")}}{{album.size}}0000{{$t("outside.张商品图片")}}</div>
									</div>
									<div class="set-price">
										<div class="mg-t-15 mg-b-10">
											<span class="tx-orange tx-24">{{album.price}}</span>
											<span class="tx-gray-900"> {{$t("outside.元/年")}}</span>
											<!--<span class="badges tx-white bg-orange">8折</span>-->
										</div>
										<div class="mg-b-15" v-if="album.oldPrice">
											{{$t("outside.原价：")}}<del>{{album.oldPrice}}{{$t("outside.元/年")}}</del>
										</div>
										<div class="mg-b-15" v-else style="opacity: 0;">
											{{$t("outside.原价：")}}<del>{{album.oldPrice}}{{$t("outside.元/年")}}</del>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-10 pd-0" v-else>
							<span class="tx-gray-600">{{$t("outside.暂无可选套餐")}}</span>
						</div>
					</div>
					<div v-if="price > 0" class="d-flex align-items-center mg-b-20">
						<span class="mg-r-10">{{$t("outside.需要支付：")}}</span>
						<span>
							<span class="tx-orange tx-24">{{price}} </span>
							<span class="tx-gray-900"> {{$t("outside.元")}}</span>
						</span>
					</div>
					<!--<div v-if="endDate != 0" class="d-flex align-items-center">
						<span class="mg-r-10">有效期至：</span>
						<span class="tx-gray-900">{{endDate}}</span>
					</div>-->
				</div>
				<div class="modal-footer">
					<button class=" btn btn-primary mg-r-15" type="button" @click="toPay">{{$t("outside.去支付")}}</button>
					<button class=" btn btn-secondary" type="button" data-dismiss="modal">{{$t("outside.关闭")}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['open',],
		data() {
			return {
				loading: false,
				albumSets:[],
				albumConfig:"",
				active:0,
				userInfo: store.get('userInfo'),
				albumType:{
					0:this.$t('outside.免费1G容量'),
					1:this.$t('outside.5G容量'),
					2:this.$t('outside.20G容量'),
					3:this.$t('outside.100G容量'),
				},
				price:"",
				endDate:"",
				albumNow:"",
			};
		},
		computed: {
		},
		watch: {
			open() {
				this.active = 0;
				this.albumConfig = "";
				this.albumSets = [];
				this.price = "";
				this.loading = true;
			    $.api_call('api.PayRecord.getAlbumPayConfig', {}, r => {
			    	this.loading = false;
			        if (r.ErrorCode == "9999") {
			        	this.albumConfig = r.Data.Results;
			          	this.albumSets = r.Data.Results.payPlan;
			          	if(r.Data.Results.albumTime>0){
			          		this.endDate = moment(r.Data.Results.albumTime*1000).format("YYYY-MM-DD");
			          	}else{
			          		this.endDate = r.Data.Results.albumTime
			          	}
			          	if(Number(this.albumConfig.albumType) > 0){
			          		this.albumNow = this.albumSets[Number(this.albumConfig.albumType)].size;
			          	}else{
			          		this.albumNow = 0;
			          	}
			        } else {
			          if (r.ErrorCode == "1002") {
			            userFailure(this);
			          } else {
			            ShowTip(r.Message, "danger");
			          }
			        }
			    });
			}
		},
		methods: {
			timeFormat_1(val) {
				console.log(moment(val*1000).format("YYYY-MM-DD hh:mm:ss"))
		      	return moment(val*1000).format("YYYY-MM-DD");
		   	},
			toPay(){
				if(!this.active){
					ShowTip(this.$t('outside.请先选择你需要的套餐'),"danger");
					return;
				}
				let PayWindow = window.open(
		          "/blank.html",
		          "pay-window2",
		          undefined,
		          true
		        );
		        $.api_call("api.PayRecord.createAlbumPay", {
		        	albumType: this.active
		        }, r => {
		          if (r.ErrorCode == "9999") {
		            $("#modalAlbumSet").modal("hide");
		            this.$emit("start_pay", r.Data.Results.payCode);
		            PayWindow.location = r.Data.Results.payurl;
		          } else {
		            if (r.ErrorCode == "1002") {
		              userFailure(this);
		            } else {
		              ShowTip(r.Message, "danger", 3000);
		            }
		          }
		        });
			},
			getActive(i){
				this.active = i;
				this.loading = true;
			    $.api_call('api.PayRecord.getAlbumAmount', {
			    	albumType: Number(this.active)
			    }, r => {
			    	this.loading = false;
			        if (r.ErrorCode == "9999") {
			          this.price = r.Data.Results.price;
			          this.endDate = r.Data.Results.endDate;
			        } else {
			          if (r.ErrorCode == "1002") {
			            userFailure(this);
			          } else {
			            ShowTip(r.Message, "danger");
			          }
			        }
			    });
			}
		}
	};
</script>

<style>
.set-warp{
    background: #f6f6f6;
    border: 2px solid rgba(0,0,0,.1);
    border-radius: 5px;
    cursor: pointer;
}
.set-warp.active,.set-warp:active,.set-warp:focus{
	/*#148ea1*/
	border-color: #148ea1;
}
.set-warp:hover{
	border-color: #17a2b8;
}
.set-warp>div{
	padding: 15px 5px;
}
.set-warp>div.set-price{
	background: #fff;
	text-align: center;
}
.badges{
	padding: 2px 5px;
    border-radius: 3px;
    font-size: 14px;
    margin-left: 5px;
}
</style>